import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {listItemStyles} from '../../lists/list-item'
import {ListItem as RmwcListItem} from '@rmwc/list'
import '@rmwc/list/styles'

const theme = ({theme}) => css`
  .mdc-drawer.mdc-theme--on-${theme} &&&.mdc-list-item--activated {
    color: var(--mdc-theme-on-${theme});
  }
`

const StyledRmwcListItem = styled(RmwcListItem)`
  ${listItemStyles}
  ${theme({theme: 'primary2'})};
`

const DrawerListItem = ({children, ripple = false, ...otherProps}) => (
  <StyledRmwcListItem ripple={ripple} {...otherProps}>
    {children}
  </StyledRmwcListItem>
)

DrawerListItem.propTypes = {
  children: PropTypes.any,
  ripple: PropTypes.bool
}

export {DrawerListItem}
